import React, { useState, useEffect, useRef } from 'react';
import { Button, Row, Col, Form, Card, Container } from 'react-bootstrap';
import 'leaflet/dist/leaflet.css';
import './AutoEmail.css';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

function AutoEmail() {
    useRef();
    const [ , setShowMap] = useState(false);
    const [emailGroups, setEmailGroups] = useState([]);
    const [bulletins] = useState([
        {
          id: 1,
          message: "FireRisk Bulletin",
          pdf: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
          timestamp: "2025-01-20 14:00",
        },
        {
          id: 2,
          message: "FireRisk started track Bulletin",
          pdf: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
          timestamp: "2025-01-20 15:30",
        },
        {
          id: 3,
          message: "FireRisk severe track Bulletin",
          pdf: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
          timestamp: "2025-01-21 10:45",
        },
        {
          id: 4,
          message: "FireRisk landfall track Bulletin",
          pdf: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
          timestamp: "2025-01-21 11:45",
        },
      ]);
    // Fetch user groups
    const fetchGroupData = async () => {
        try {
            const response = await fetch(`${backendUrl}Municipalities/auto_email_user_groups/`);
            const result = await response.json();
            setEmailGroups(result.groups);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        fetchGroupData();
    }, []);

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const formObject = {
            assign_group_names: formData.get("assign_group_names"),
            group_name: formData.get("new_group_name"),
            new_email: formData.get("new_email")
        };
        try {
            const response = await axios.post(`${backendUrl}Municipalities/save_auto_email_user_group/`, formData, {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formObject),
            });

            if (response.status === 201) {
                alert("Group data updated successfully.");
                fetchGroupData();
                setShowMap(false);
                e.target.reset();
            }
        } catch (error) {
            console.error('There was an error!', error);
        }
    };
    <button onClick={handleModalSubmit}></button>


    return (
        <>
        <div className='email-container'>
        <Container fluid className="auto-email-container">
  <Row>
    {/* Auto Email Setup Section */}
    <Col md={6} lg={5}>
      <Card className="auto-email-card">
        <Card.Body>
          <div className="card-header-section">
            <h3 className="auto-email-header">

                Auto Email Setup</h3>
            {/* <Button variant="outline-primary" className="history-btn">
              History
            </Button> */}
          </div>

          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="label-text">Set Auto Email</Form.Label>
              <div className="radio-group">
                <Form.Check inline label="Yes" name="set_email" type="radio" />
                <Form.Check inline label="No" name="set_email" type="radio" />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="label-text">Show All Sub-Municipalities</Form.Label>
              <div className="radio-group">
                <Form.Check inline label="Yes" name="show_sm" type="radio" />
                <Form.Check inline label="No" name="show_sm" type="radio" />
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Row>
                <Col md={8}>
                  <Form.Label className="label-text">User Group</Form.Label>
                  <Form.Select defaultValue="" name="group_names">
                    <option value="" disabled hidden>
                      -- Select --
                    </option>
                    {emailGroups.map((group, index) => (
                      <option key={index} value={group.id}>
                        {group.group_name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={3} className="text-end">
                  <Button onClick={() => setShowMap(true)} variant="info" size="sm" className="assign-group-btn">
                    ➕ Assign User Group
                  </Button>
                </Col>
                
              </Row>
            </Form.Group>

            <div className="text-center">
              <Button className="submit-btn" variant="primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Col>

    {/* Bulletin Table Section */}
    <Col md={6} lg={7}>
      <div className="bulletin-table-container">
        <h3 className="bulletin-header">Bulletins History</h3>
        <table className="bulletin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Bulletin</th>
              <th>pdf</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {bulletins.map((bulletin) => (
              <tr key={bulletin.id}>
                <td>{bulletin.id}</td>
                <td>{bulletin.message}</td>

           <td>
  <a href={bulletin.pdf} target="_blank" rel="noopener noreferrer">
    View PDF
  </a>
</td>

                <td>{bulletin.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Col>
  </Row>
</Container>
     
</div>
    </>

    );
}

export default AutoEmail;